import React from 'react';
import { Provider } from './Provider';

const Wrapper = ({children}) => {
    return <Provider>
        {children}
    </Provider>
}

export default Wrapper;
